import curry from 'ramda/es/curry'

let basePath    = window.location.origin+'/storage/images/'
let baseFilePath    = window.location.origin+'/storage/'
let iconBasePath    = window.location.origin+'/images/app/'
let url         = curry( (category,image) => basePath + category + '/' + image )
let fileurl     = curry( (category,file) => baseFilePath + category + '/' + file )
let navIconsUrl    = (image) => iconBasePath + 'nav-icons/' + image
let iconsUrl    = (image) => iconBasePath + 'icons/' + image
let logosUrl    = url('logos')
let picsUrl     = url('pics')
let filesUrl     = fileurl('files')
let mainCatUrl  = url('hauptkategorien')
let mainCatUrlGreen = url('hauptkategorien/test-mode')


export const prependOriginUrl = x => window.location.origin + '/' + x

export default {
    basePath,

    calcPicsPath: picsUrl,
    calcFilesPath: filesUrl,

    navIcons: {
        notepadIcon:        navIconsUrl('Merkzettel-Icon.svg'),
        revisionIcon:       navIconsUrl('Korrekturbereich-Icon.svg'),
        statsIcon:          navIconsUrl('Auswertung-Icon.svg'),
        myAreaIcon:         navIconsUrl('Mein-Bereich-Icon.svg'),
        myAreaIconSmall:    navIconsUrl('Mein-Bereich-Icon-klein.svg'),
        exerciseIcon:      navIconsUrl('Uebungsmodus-Icon.svg'),
        testIcon:           navIconsUrl('Testmodus-Icon.svg'),
        testIconGreen:      navIconsUrl('Testmodus-Icon-gruen.svg'),
        prevArrow:          navIconsUrl('Button-prev.svg'),
        nextArrow:          navIconsUrl('Button-next.svg'),
        jumpPrevArrow:      navIconsUrl('Button-prev.svg'),
        jumpNextArrow:      navIconsUrl('Button-next.svg'),
        jumpOut:            navIconsUrl('Button-jumpout.svg'),
        btnBack:            navIconsUrl('Button-zurueck-blau.svg'),
        btnBackGreen:       navIconsUrl('Zurueck-Button-blau.svg'),
        homeBtn:            navIconsUrl('Home-Icon-Invers.svg'),
        homeBtnGreen:       navIconsUrl('Testmodus-Home-Icon-Invers.svg'),

        correctSign:        navIconsUrl('Antwort-richtig-Haeckchen.svg'),
        errorSign:          navIconsUrl('Antwort-falsch-Kreuz.svg'),
        uneditedSign:       navIconsUrl('Antwort-unbeantwortet-Strich.svg'),
        forwardArrow:       navIconsUrl('Pfeil-blau-rechts.svg'),
        forwardArrowGreen:  navIconsUrl('Pfeil-gruen-rechts.svg'),
        binIcon:            navIconsUrl('Muelleimer-Icon.svg'),

        chartIcon:          navIconsUrl('Chart-Gesamt.svg'),
        chartIconDetails:   navIconsUrl('Chart-Details.svg'),

        wecademyIcon:       navIconsUrl('WeCademy-Icon.svg'),
    },

    icons: {
        clockIcon:          iconsUrl('clock_blue.svg'),
        clockIconGreen:     iconsUrl('clock_green.svg'),
        testResultSuccess:  iconsUrl('Testergebnis-Icon-Haken.png'),
        testResultFailure:  iconsUrl('Testergebnis-Icon-Kreuz.png'),
        sortRandom:  iconsUrl('Testmodus-sort-random.png'),
        sortEasy2Difficult:  iconsUrl('Testmodus-sort-leicht-zu-schwer.png'),
        sortDifficult2Easy:  iconsUrl('Testmodus-sort-schwer-zu-leicht.png'),
        offerPercent:  iconsUrl('offer-percent.svg'),
    },

    logos: {
        etrainerPlus:       logosUrl('eTrainer-plus-Logo_default.png'),
        etrainer:           logosUrl('eTrainer-Logo.svg'),
        ausbildungspark:    logosUrl('AP-Logo.svg'),
    },

    mainCategories: {
        allgemeinWissen:            mainCatUrl('Allgemeinwissen-Icon.svg'),
        allgemeinWissenGreen:       mainCatUrlGreen('Allgemeinwissen-Icon.svg'),
        erinnerung:                 mainCatUrl('Erinnerungsvermoegen-Icon.svg'),
        erinnerungGreen:            mainCatUrlGreen('Erinnerungsvermoegen-Icon.svg'),
        fachWissen:                 mainCatUrl('Fachbezogenes-Wissen-Icon.svg'),
        fachWissenGreen:            mainCatUrlGreen('Fachbezogenes-Wissen-Icon.svg'),
        fremdsprachen:              mainCatUrl('Fremdsprachen-Icon.svg'),
        fremdsprachenGreen:         mainCatUrlGreen('Fremdsprachen-Icon.svg'),
        konzentration:              mainCatUrl('Konzentrationsvermoegen-Icon.svg'),
        konzentrationGreen:         mainCatUrlGreen('Konzentrationsvermoegen-Icon.svg'),
        kreativitaet:               mainCatUrl('Kreativitaet-Icon.svg'),
        kreativitaetGreen:          mainCatUrlGreen('Kreativitaet-Icon.svg'),
        logik:                      mainCatUrl('Logisches-Denkvermoegen-Icon.svg'),
        logikGreen:                 mainCatUrlGreen('Logisches-Denkvermoegen-Icon.svg'),
        mathe:                      mainCatUrl('Mathe-Icon.svg'),
        matheGreen:                 mainCatUrlGreen('Mathe-Icon.svg'),
        orientierung:               mainCatUrl('Orientierungsvermoegen-Icon.svg'),
        orientierungGreen:          mainCatUrlGreen('Orientierungsvermoegen-Icon.svg'),
        sprache:                    mainCatUrl('Sprachbeherrschung-Icon.svg'),
        spracheGreen:               mainCatUrlGreen('Sprachbeherrschung-Icon.svg'),
        technik:                    mainCatUrl('Technisches-Verstaendnis-Icon.svg'),
        technikGreen:               mainCatUrlGreen('Technisches-Vertaendnis-Icon.svg'),
        visuelles:                  mainCatUrl('Visuelles-Denkvermoegen-Icon.svg'),
        visuellesGreen:             mainCatUrlGreen('Visuelles-Denkvermoegen-Icon.svg'),
    }
}